// App.js (version corrigée - sans AdminLayout)
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { isAdmin } from "./utils/auth";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";

// Pages publiques
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetails from "./pages/ServiceDetails";
import Models from "./pages/Models";
import ModelDetail from "./pages/ModelDetail";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Quotation from "./pages/Quotation";
import Faq from "./pages/faq";
// Pages admin
import LoginAdmin from "./pages/LoginAdmin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminServices from "./pages/AdminServices";
import AdminModels from "./pages/AdminModels";
import AdminClients from "./pages/AdminClients";
import AdminContacts from "./pages/AdminContacts";
import AdminPricing from "./pages/AdminPricing";
import AdminQuotes from "./pages/AdminQuotes";
import AdminStats from "./pages/AdminStats";

// Composant de protection de route simple
const ProtectedRoute = ({ children }) => {
  return isAdmin() ? children : <Navigate to="/admin/login" />;
};

// Layout public
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Routes publiques avec layout */}
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
        <Route path="/services/:id" element={<PublicLayout><ServiceDetails /></PublicLayout>} />
        <Route path="/models" element={<PublicLayout><Models /></PublicLayout>} />
        <Route path="/models/:id" element={<PublicLayout><ModelDetail /></PublicLayout>} />
        <Route path="/pricing" element={<PublicLayout><Pricing /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
        <Route path="/faq" element={<PublicLayout><Faq /></PublicLayout>} />
        <Route path="/devis" element={<PublicLayout><Quotation /></PublicLayout>} />
        {/* Routes admin */}
        <Route path="/admin/login" element={<LoginAdmin />} />
        
        <Route path="/admin/dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/services" element={
          <ProtectedRoute>
            <AdminServices />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/models" element={
          <ProtectedRoute>
            <AdminModels />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/clients" element={
          <ProtectedRoute>
            <AdminClients />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/contacts" element={
          <ProtectedRoute>
            <AdminContacts />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/pricing" element={
          <ProtectedRoute>
            <AdminPricing />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/quotes" element={
          <ProtectedRoute>
            <AdminQuotes />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/stats" element={
          <ProtectedRoute>
            <AdminStats />
          </ProtectedRoute>
        } />

        {/* Redirection admin */}
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />

        {/* Route 404 */}
        <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
      </Routes>
    </BrowserRouter>
  );
}